import React from "react";
import styled from 'styled-components';
import { PRIMARY } from "@etiquette-ui/colors";
import { device } from "../../../../Theme";

const Container = styled.li`
    display: flex;
    align-items: center;
    justify-content: start;
    text-align: left;

    width: 100%;
    
    list-style: none;
    margin-bottom: 10px;
    position: relative;

    .content {
        padding-left: 25px;
    }

    .bullet {
        height: 7px;
        width: 7px;
        border-radius: 50%;
        border: 1px solid ${PRIMARY};

        position: absolute;
        left: 8px;
        top: 5px;
    }
`;

const List = ({ text }) => (
    <Container>
        <span 
            className="bullet" 
            data-sal-delay-='400' 
            data-sal="slide-right" 
            data-sal-duration='300'
            data-sal-easing="ease-out-cubic"  
        ></span>
        <span className="content" data-sal="slide-up" data-sal-easing="ease-out-cubic" data-sal-duration='600'>
            {text}
        </span>
    </Container>
);
export default List;